import React from 'react';
export function AspirationalSection() {
  return <section className="py-12 px-4 bg-brand-teal text-white relative overflow-hidden" data-id="element-1">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-2"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-3">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 leading-tight" data-id="element-4">
          Imagine bajar a tomar un café y que su única preocupación sea
          disfrutar del aroma.
        </h2>

        {/* IMAGEN 2 (Perro en Terraza Santiago) */}
        <div className="w-full max-w-2xl mx-auto rounded-[20px] overflow-hidden relative shadow-2xl mb-10" data-id="element-5">
          <img src="https://cdn.magicpatterns.com/uploads/mjx4fwPtCm344jpP4cBFWC/imagen_2.png" alt="Perro tranquilo en terraza de Santiago" className="w-full h-auto" data-id="element-6" />
        </div>

        <p className="text-xl md:text-2xl font-serif italic text-brand-gold-light max-w-2xl mx-auto" data-id="element-7">
          "Sin tirones. Sin disculpas. Solo paz."
        </p>
      </div>
    </section>;
}